import type { IScoringRuleDto } from "app/pages/sales-intelligence/domain/leads/types/scoring-config";

export type ScoringRuleWizardMode = "create" | "edit";

/**
 * Teams the wizard's team step starts with. Editing shows what the rule already applies to, while a
 * new rule starts from the caller's default — the team page preselects the team being configured.
 */
export const resolveInitialTeamIds = (
    mode: ScoringRuleWizardMode,
    initialRule: IScoringRuleDto | undefined,
    defaultTeamIds: readonly number[],
): number[] => {
    if (mode === "edit") {
        return initialRule?.teamIds ? [...initialRule.teamIds] : [];
    }

    return [...defaultTeamIds];
};
